import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowBottomLeftIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M7.46 7.36V15.24L17.04 5.64L18.38 6.98L8.82 16.56H16.66V18.4H5.62V7.36H7.46Z" />
    </SvgIcon>
  );
});
